import { useEffect, useState } from "react"
import {
  strategiesList,
  Strategy,
  StrategyParams,
  StrategyProps
} from "../strategies"
import { constants } from "@lib/constants"
import { DiscountCurrency } from "."
import {
  formatEther,
  formatUnits,
  isAddress,
  parseEther,
  parseUnits
} from "viem"
import { availableCurrencies } from "@components/ui/AddProductFormPrice/AddProductFormPrice"

const label = "NFT Tiered Discount"
const description = "Offer discounts based on NFTs owned by the buyer"
const strategyLabel = "NFTDiscount"

export enum NFTType {
  ERC721,
  ERC1155
}

export type Discount = {
  nft: string
  discount: number
  minQuantity: number
  nftType?: NFTType
  tokenId?: number
}

export type DiscountParams = {
  basePrice: number
  discounts: Discount[]
}

const Component = ({
  priceParams,
  setPriceParams,
  productCurrency
}: StrategyProps) => {
  const initParams =
    (priceParams.args && priceParams.args[0] && priceParams.args[0][0]) || []
  const [discountParams, setDiscountParams] = useState<DiscountParams>({
    basePrice: initParams[1]
      ? Number(
          initParams[0] == availableCurrencies[1].value
            ? formatUnits(initParams[1], 6)
            : formatEther(initParams[1])
        )
      : 0,
    discounts: initParams[4]?.length
      ? initParams[4].map((el: any) => ({ ...el, discount: el.discount / 100 }))
      : [
          {
            nft: "",
            discount: 0,
            minQuantity: 1,
            nftType: 0,
            tokenId: 0
          }
        ]
  })

  const strategy = strategiesList[strategyLabel]

  useEffect(() => {
    const { label, abi } = strategy
    const address =
      constants[process.env.NEXT_PUBLIC_CHAIN_ID][
        process.env.NEXT_PUBLIC_ENVIRONMENT
      ].strategies[label]

    // filter and sort discounts in descending order
    const cleanedDiscounts = discountParams.discounts
      .filter((el) => isAddress(el.nft) && el.discount && el.minQuantity)
      .sort((a, b) => b.discount - a.discount)
      .map((el) => ({ ...el, discount: el.discount * 100 }))

    const newPriceParams: StrategyParams = {
      ...priceParams,
      label,
      address,
      abi,
      args: [
        [
          [
            productCurrency,
            productCurrency == availableCurrencies[1].value
              ? parseUnits(discountParams.basePrice.toString(), 6)
              : parseEther(discountParams.basePrice.toString()),
            false, // isFree
            1, // Relative DiscountType
            cleanedDiscounts
          ]
        ]
      ]
    }

    setPriceParams(newPriceParams)
  }, [discountParams, productCurrency])

  return (
    <>
      <DiscountCurrency
        discountParams={discountParams}
        setDiscountParams={setDiscountParams}
        currency={productCurrency}
      />
    </>
  )
}

const hook: Strategy = { label, description, Component }

export default hook
//
